import BackendConnector from './backendConnector';

export default class TalenyaHttpService {
    static getRefreshMetaData() {
        return BackendConnector.get('metadata/refresh');
    }

    static blockActiveSessions() {
        return BackendConnector.post('user/blockMemorySessions');
    }

    static blockUserSessions(email) {
        return BackendConnector.post('user/blockSessions', { email });
    }

    static clearAllCaches() {
        return BackendConnector.post('cache/clearAll');
    }
}
